<template>
  <hsc-window-style-metal>
    <hsc-window
      :is-open="isVisibleSharingWindow"
      :title="`Sharing - ${getElementNameSharingWindow}`"
      :resizable="true"
      :min-height="450"
      :min-width="450"
      :width="510"
      :height="450"
    >
      <div
        v-if="isLoading"
        id="loading-animation"
      >
        <b-spinner
          variant="primary"
          label="Loading"
        />
      </div>
      <div
        v-else
        class="main-container"
      >
        <label class="label-main ml-2 mt-2 ">User selection</label>
        <multiselect
          v-model="selected"
          :hide-selected="true"
          tag-placeholder="Select users to share"
          placeholder="Add users' email to share"
          label="email"
          track-by="email"
          :options="filteredOptions"
          :multiple="true"
          :taggable="true"
          :loading="isLoadingElem > 0"
          class="email-sharing-multiselect"
          @tag="addTag"
          @focus="showSuggestions = true"
          @search-change="handleSearchChange"
          @select="onSelect"
        >
          <template #tag="{ option, remove }">
            <span
              v-if="option.name !== null"
              class="custom-tag"
              :class="{ 'editor-user': option.accesstype }"
            ><span>{{
               option.name
             }}</span>
              <ToggleButton
                v-model="option.accesstype"
                class="my-0 mx-1"
                :value="true"
                :labels="{ checked: 'Editor', unchecked: 'Viewer' }"
                :width="60"
                :height="20"
              />
              <span
                class="custom-remove m-1"
                @click="remove(option)"
              >❌</span>
            </span>
            <span
              v-else
              class="custom-tag invitation-tag"
              :class="{ 'editor-invitation': option.accesstype }"
            ><span>{{
               option.email
             }}-[Invitation]</span>
              <ToggleButton
                v-model="option.accesstype"
                class="my-0 mx-1"
                :value="true"
                :labels="{ checked: 'Editor', unchecked: 'Viewer' }"
                :width="60"
                :height="20"
              />
              <span
                class="custom-remove m-1"
                @click="remove(option)"
              >❌</span>
            </span>
          </template>
        </multiselect>
      </div>
      <div class="btns-commands buttons-page">
        <b-button
          variant="danger"
          class="mr-3"
          @click="closeAction"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="isLoadingElem > 0"
          @click="saveSharing"
        >
          Done
        </b-button>
      </div>
    </hsc-window>
  </hsc-window-style-metal>
</template>

<script>
//https://github.com/michitaro/vue-window
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import { ToggleButton } from 'vue-js-toggle-button'

const zoneNotify = 'Share Window'

export default {
    name: 'ShareWindow',
    components: {
        Multiselect,
        ToggleButton
    },
    data() {
        return {
            isLoading: false,
            changed: false,
            isLoadingElem: 0,
            selected: [],
            options: [],
            dbDataShared: [], //Stores the current status in the DB so it is possible to compare after
            showSuggestions: false, // Flag to control the visibility of suggestions
            search:''
        }
    },
    computed: {
        ...mapGetters([
            'getElementNameSharingWindow',
            'getElementIdSharingWindow',
            'getTypeSharingWindow',
            'isVisibleSharingWindow',
            'getUsersSharingMiddleware',
            'getEmailMiddlewareAuth',
            'getCurrentClusterNavigation',
            'getNameCurrClusterNavigation'
        ]),
        filteredOptions() {
            if (!this.search || this.search.length === 0) {
                return this.options; // Return all options if no search query
            } else {
                const searchTerm = this.search.toLowerCase();
                return this.options.filter(option => {
                    return option.email.toLowerCase().includes(searchTerm);
                });
            }
        }
    },

    watch: {
        async isVisibleSharingWindow(newVal) {
            try {
                this.changed = false
                this.isLoading = true
                if (newVal) {
                    this.selected = []
                    const sharedEmailsResponse = await this.fetchSharedClusterEmailsByUser({
                        userId: this.getEmailMiddlewareAuth
                    })

                    if(sharedEmailsResponse.data){
                        this.options = sharedEmailsResponse.data.map(email => ({
                            email: email,
                            name: null,
                            accesstype: true,
                        }));
                    }
                    else{
                        this.options =[]
                    }

                    this.dbDataShared = []
                    const success = await this.readUsersSharingMiddleware()
                    if (!success) {
                        this.closeAction()
                        return
                    }
                    if (this.getTypeSharingWindow === 'cluster') {
                        if (typeof (this.getUsersSharingMiddleware.clusterInfo) !== 'undefined') {
                            this.dbDataShared = this.getUsersSharingMiddleware.clusterInfo.filter(c => c.clusterId === this.getElementIdSharingWindow[0].id)
                            this.dbDataShared.forEach(elem => {
                                this.addUserToList(elem.sharedWith, elem.accesstype)
                            })
                        }
                    } else if (this.getTypeSharingWindow === 'report') {
                        if (typeof (this.getUsersSharingMiddleware.reportInfo) !== 'undefined' && this.getUsersSharingMiddleware.reportInfo.length > 0) {
                            let auxDbDataShared = null
                            for (const report of this.getElementIdSharingWindow) {
                                const dataSharedReport = this.getUsersSharingMiddleware.reportInfo.filter(c => c.reportId === report.id)
                                if (auxDbDataShared === null) {
                                    auxDbDataShared = dataSharedReport
                                } else {
                                    const filteredArray = dataSharedReport.filter(value => auxDbDataShared.some(value2 => value2.sharedWith === value.sharedWith));
                                    if (filteredArray.length !== dataSharedReport.length) {
                                        this.$alert(
                                            `Report '${report.name}' has been shared with different users. Verify that all the reports has been shared with the same users.`,
                                            'Sharing mismatch',
                                            'info',
                                        )
                                        this.setConfigSharingWindow({ visibility: false })
                                    }
                                    auxDbDataShared = filteredArray
                                }
                            }
                            this.dbDataShared = auxDbDataShared
                            //Add the intersection of the elements
                            this.dbDataShared.forEach(elem => {
                                this.addUserToList(elem.sharedWith, elem.accesstype)
                            })
                        }
                    }
                }
            } catch (error) {

                const errTitle = 'Error Saving'
                const errText = 'Error saving the configuration. Please contact the administrator of the system.'
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotify)
            } finally {
                this.isLoading = false
            }
        },
    },
    methods: {
        ...mapActions([
            'setConfigSharingWindow',
            'readUsersSharingMiddleware',
            'retrieveBasicUserDataMiddlewareAuth',
            'shareClusterMiddleware',
            'updateShareClusterMiddleware',
            'deleteShareClusterMiddleware',
            'shareReportMiddleware',
            'updateShareReportMiddleware',
            'deleteShareReportMiddleware',
            'fetchSharedClusterEmailsByUser'
        ]),
        closeAction() {
            if (this.changed) {
                this.$emit('closed', this.getTypeSharingWindow)
            }
            this.setConfigSharingWindow({ visibility: false })
        },
        async saveSharing() {
            this.isLoading = true

            //Compare the original list and the new one
            const updateValues = this.selected.filter(s => this.dbDataShared.some(e => s.email === e.sharedWith && e.accesstype !== s.accesstype))
            const removeValues = this.dbDataShared.filter(s => !this.selected.some(e => e.email === s.sharedWith))
            const addValues = this.selected.filter(s => !this.dbDataShared.some(e => s.email === e.sharedWith))

            if (addValues.length === 0 && updateValues.length === 0 && removeValues.length === 0) {
                this.closeAction()
                return
            }

            this.changed = true
            let success = true
            let failReponse = {}
            let elementText = ''
            try {
                if (this.getTypeSharingWindow === 'cluster') {
                    elementText = `cluster '${this.getElementNameSharingWindow}'`
                    if (addValues.length > 0) {
                        const responseAdd = await this.shareClusterMiddleware({
                            clusterName: this.getElementNameSharingWindow,
                            clusterId: this.getElementIdSharingWindow[0].id,
                            users: addValues
                        })
                        if(!responseAdd.success)
                            failReponse = responseAdd;
                        success = success && responseAdd.success //All the values should be success
                    }
                    if (updateValues.length > 0) {
                        const responseUpdate = await this.updateShareClusterMiddleware({
                            clusterId: this.getElementIdSharingWindow[0].id,
                            users: updateValues
                        })
                        if(!responseUpdate.success)
                            failReponse = responseUpdate;
                        success = success && responseUpdate.success //All the values should be success
                    }
                    if (removeValues.length > 0) {
                        const mapedRemove = removeValues.map(elem => { return elem.sharedWith })
                        const responseRemove = await this.deleteShareClusterMiddleware({
                            clusterId: this.getElementIdSharingWindow[0].id,
                            users: mapedRemove
                        })
                        if(!responseRemove.success)
                            failReponse = responseRemove;
                        success = success && responseRemove.success //All the values should be success
                    }
                } else if (this.getTypeSharingWindow === 'report') {
                    elementText = 'selected reports'
                    if (addValues.length > 0) {
                        const responseAdd = await this.shareReportMiddleware({
                            reports: this.getElementIdSharingWindow,
                            users: addValues,
                            clusterId: this.getCurrentClusterNavigation,
                            clusterName: this.getNameCurrClusterNavigation
                        })
                        if(!responseAdd.success)
                            failReponse = responseAdd;
                        success = success && responseAdd.success //All the values should be success
                    }
                    if (updateValues.length > 0) {
                        const responseUpdate = await this.updateShareReportMiddleware({
                            reports: this.getElementIdSharingWindow,
                            users: updateValues
                        })
                        if(!responseUpdate.success)
                            failReponse = responseUpdate;
                        success = success && responseUpdate.success //All the values should be success
                    }
                    if (removeValues.length > 0) {
                        const mapedRemove = removeValues.map(elem => { return elem.sharedWith })
                        const responseRemove = await this.deleteShareReportMiddleware({
                            reports: this.getElementIdSharingWindow,
                            users: mapedRemove
                        })
                        if(!responseRemove.success)
                            failReponse = responseRemove;
                        success = success && responseRemove.success //All the values should be success
                    }
                } else {
                    success = false
                }
                if (success) {
                    await this.$alert(
                        `Sharing configuration for ${elementText} updated`,
                        'Success',
                        'success',
                    )
                    this.closeAction()
                } else {
                    if(failReponse?.code === 403){
                        await this.$alert(
                            `Error saving the configuration for ${elementText}.${failReponse.message}`,
                            failReponse.message || 'Not authorized',
                            'info',
                        )
                    }else{
                        await this.$alert(
                            `Error saving the configuration for ${elementText}. Please verify your internet connection and try again.`,
                            'Error',
                            'error',
                        )
                    }
                }
            } catch (error) {

                const errTitle = 'Error Saving'
                const errText = 'Error saving the configuration. Please contact the administrator of the system.'
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotify)
            } finally {
                this.isLoading = false
            }
        },
        emailValidation(email) {
            return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(email)
        },
        async addTag(newTag) {
            const splitNewTag = newTag.split(/[\n\r ]/);
            if (splitNewTag.length > 1) {
                splitNewTag.forEach(tag => { this.addTag(tag); });
                return;
            }
            try {
                if (this.getEmailMiddlewareAuth === newTag) {
                    const infoTitle = 'Not valid entry';
                    const infoText = 'You have entered your own email';
                    this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO, infoTitle, infoText, zoneNotify);
                    return;
                }
                if (!this.emailValidation(newTag)) {
                    const errTitle = 'Not valid entry';
                    const errText = `The element '${newTag}' is not a valid email`;
                    this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotify);
                    return;
                }
                await this.addUserToList(newTag);
            } catch (error) {
                const errTitle = 'Not valid entry';
                const errText = 'Error while adding the user. Please try again in a few minutes.';
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotify);
            }
        },
        onSelect(selectedOption){
            this.getTag(selectedOption.email)
        },
        async getTag(newEmail, accesstype = true){
            try {
                this.isLoadingElem++
                let tag = this.options.find(t => t.email === newEmail)
                const isTagExists = typeof(tag) !== 'undefined'
                if(isTagExists && tag.name && tag.name !==null){
                    return {isTagExists, tag}
                }

                const userData = await this.retrieveBasicUserDataMiddlewareAuth({ email: newEmail });
                if(isTagExists){
                    tag.accesstype = accesstype
                }else{
                    tag = {
                        email: newEmail,
                        name: null,
                        accesstype: accesstype
                    }
                }
                if (!userData.success) {
                    const infoTitle = 'Undentified user'
                    const infoText = `The email '${newEmail}' does not have an account in djuli.`
                    this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO, infoTitle, infoText, zoneNotify)
                    return
                }
                tag.name = userData.data.displayName
                return {isTagExists, tag}
            } catch (error) {
                const errTitle = 'Not valid entry'
                const errText = `Error while retrieving user information for email ${newEmail}. Please try again in a few minutes.`
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotify)
                return
            } finally {
                this.isLoadingElem--
            }
        },
        async addUserToList(newEmail, accesstype = true) {
            try {
                const {isTagExists, tag} = await this.getTag(newEmail, accesstype)
                if(typeof(tag) === 'undefined'){
                    return
                }
                if (!isTagExists) {
                    this.options.push(tag)
                }
                this.selected.push(tag)
            } catch (error) {
                const errTitle = 'Not valid entry'
                const errText = `Error while including ${newEmail}. Please try again in a few minutes.`
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotify)
            } finally {
                this.isLoadingElem--
            }
        },
        handleSearchChange(val) {
            this.search = val;
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>

<style lang="scss" scoped>
#loading-animation {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.buttons-page {
    position: absolute;
    bottom: 0;
}

.btn-select-all {
    position: absolute;
    top: 2.75rem;
    right: 0;
}

.btns-commands {
    right: 0;
}

.main-container {
    height: 80%;
}

::v-deep .titlebar {
    background: #388A32 !important;
    font-weight: bold;
    color: white;
}

.label-main {
    font-size: 0.85rem;
    color: #555
}

.custom-tag {
    background: #4fc08d;
    border-radius: 0.5rem;
    padding: 0.35rem;
    margin: 0.25rem;
    display: inline-block;
    font-size: 0.85rem;
}

.invitation-tag {
    background: #C77775;
}

.editor-user {
    background: #226E4C;
    color: white;
}

.editor-invitation {
    background: #856867;
    color: white;
}

.custom-remove {
    cursor: pointer;
}

.email-sharing-multiselect {
    overflow-y: auto;
    height: 100%;
}
</style>
